const template = document.createElement('template');
template.innerHTML = `
<style>
    :host {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%) translateY(20px);
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        padding: 10px 20px;
        border-radius: 25px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.9rem;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s ease, transform 0.3s ease;
        z-index: 2000;
        box-shadow: 0 4px 15px rgba(0,0,0,0.5);
        backdrop-filter: blur(5px);
    }
    :host(.visible) {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
</style>
<slot></slot>
`;

export class NotificationToast extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.timer = null;
    }

    show(message, duration = 2000) {
        this.textContent = message;
        this.classList.add('visible');
        
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.hide();
        }, duration);
    }

    hide() {
        this.classList.remove('visible');
    }
}

customElements.define('notification-toast', NotificationToast);
